import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb60aa3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "textarea-container" }
const _hoisted_2 = ["placeholder"]

import { computed, onMounted, ref, watch } from "vue";


import { defineComponent } from "vue";

const __default__ = defineComponent({});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Textarea',
  props: {
    modelValue: {},
    placeholder: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const value = computed({
  get: () => {
    return props.modelValue ?? "";
  },
  set: (v) => {
    emit("update:modelValue", v);
  },
});

const inputHeight = ref("1rem");

const inputStyle = computed(() => {
  return {
    "min-height": inputHeight.value,
  };
});

const shadow = ref(null);

const resize = () => {
  if (shadow.value) {
    inputHeight.value = `${(shadow.value as any).scrollHeight}px`;
  }
};

onMounted(() => {
  window.requestAnimationFrame(resize);

  // For some reason we need this to not cut off text
  setTimeout(() => {
    window.requestAnimationFrame(resize);
  }, 150);
});

watch(
  () => value.value,
  () => window.requestAnimationFrame(resize)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", _mergeProps(_ctx.$attrs, {
      class: "foreground textarea",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      style: inputStyle.value,
      placeholder: _ctx.placeholder
    }), null, 16, _hoisted_2), [
      [_vModelText, value.value]
    ]),
    _withDirectives(_createElementVNode("textarea", _mergeProps(_ctx.$attrs, {
      class: "shadow textarea",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
      ref_key: "shadow",
      ref: shadow,
      tabindex: "-1"
    }), null, 16), [
      [_vModelText, value.value]
    ])
  ]))
}
}

})